import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { ActivityViewType } from '../activity-view-type';

export class ActivityViewTypeBuilder {
  static fromJson(json) {
    return (json)
      ? new ActivityViewType(
        parseNumber(json.code),
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ActivityViewTypeBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/activity-view-type.builder.ts